import { Expose, Type } from 'class-transformer';

import { Default } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { SnNotification } from './notification';

export class SnNotificationTypeModel extends SnModel {
  @Expose() public id: string;
  @Expose() public name: string;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}

export class SnNotificationGroup extends SnModel {
  @Expose() public id: string;
  @Expose() public name: string;

  @Expose()
  @Type(() => SnNotificationTypeModel)
  public type: SnNotificationTypeModel;

  @Expose()
  @Type(() => SnNotification)
  @Default([])
  public notifications: SnNotification[];

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
